var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorSensorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.4 279.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.5,23.1L71.1,0.2c-2.9-0.6-5.9,0-8.2,1.8c-2.4,1.8-3.5,4.7-3.5,7.6v13.2l-49.7,0c-5.3,0-9.7,4.4-9.7,9.7 v214.1c0,5.3,4.4,9.7,9.7,9.7h49.4v13.2c0,2.9,1.5,5.6,3.5,7.6c1.8,1.5,3.8,2.1,5.9,2.1c0.6,0,1.5,0,2.1-0.3l99.4-22.9 c4.4-0.9,7.3-5,7.3-9.4V32.5C177.9,27.8,174.9,24,170.5,23.1L170.5,23.1z M59.1,237H19.4V41.9h39.7L59.1,237z M93.2,149.7 c-5.6,0-10.3-4.7-10.3-10.3c0-5.6,4.7-10.3,10.3-10.3c5.6,0,10.3,4.7,10.3,10.3C103.5,145,98.8,149.7,93.2,149.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorSensorIcon);
export default __webpack_public_path__ + "static/media/door-sensor-icon.974f029388470078391938853ccdb062.svg";
export { ForwardRef as ReactComponent };